import { ComponentsState } from './types'
import { GetterTree } from 'vuex'
import { TRootState } from '../types'

export default {
  getSystemComponents: (state: ComponentsState) => {
    return state.components
  }
} as GetterTree<ComponentsState, TRootState>
